/**
 * Registers the 'expandableContainer' directive with the given module.
 * This directive is used to create an expandable container element.
 * 
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export function registerExpandableContainerDirective(module) {
    module.directive('expandableContainer', function($compile, $bridges) {
        return {
            restrict: 'AE', // 'AE' means the directive can be used as an attribute or element.
            replace: true,
            scope: {
                expandableWidth: "@", // Attribute binding for width
                expandableHeight: "@", // Attribute binding for height
                expandableElementClass: "@", // Attribute binding for class
                size: "@", // Attribute binding for size
                colPosition: "@" // Attribute binding for column position
            },
            templateUrl: '/views/ib/components/ExpandCollapseDirective.html',
            controller: 'ExpandableContainerController'
        };
    });
}